var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMngMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5001 6.72217H4.5V19.2778H21.5001V6.72217ZM3 5.22217V20.7778H23.0001V5.22217H3Z",
    fill: "#8C8C8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 10.2222V10.7778H8.55549H10.7777V10.2222V9.66666H8.5478H6.33325V10.2222Z",
    fill: "#8C8C8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 12.4444V13H9.11104H11.8888V12.4444V11.8889H9.11104H6.33325V12.4444Z",
    fill: "#8C8C8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33325 16.8889V17.4444H13H19.6667V16.8889V16.3333H12.99H6.33325V16.8889Z",
    fill: "#8C8C8C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4093 11.4634C19.6581 11.4634 19.762 11.1258 19.5599 10.9702L16.4847 8.60781C16.4408 8.57383 16.3878 8.55551 16.3333 8.55551C16.2789 8.55551 16.2259 8.57383 16.1819 8.60781L13.1068 10.9702C12.9047 11.125 13.0086 11.4634 13.2582 11.4634H13.7566V14.6439H13.1769C13.1414 14.6439 13.1124 14.6746 13.1124 14.712V15.1542C13.1124 15.1916 13.1414 15.2222 13.1769 15.2222H19.4898C19.5252 15.2222 19.5542 15.1916 19.5542 15.1542V14.712C19.5542 14.6746 19.5252 14.6439 19.4898 14.6439H18.91V11.4634H19.4093ZM15.2785 14.6439H14.3364V11.4634H15.2785V14.6439ZM16.8004 14.6439H15.8583V11.4634H16.8004V14.6439ZM18.3303 14.6439H17.3801V11.4634H18.3303V14.6439Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMngMenuIcon);
export default __webpack_public_path__ + "static/media/account-mng-menu-icon.123d2eeaaf17502a9fd942d694a36599.svg";
export { ForwardRef as ReactComponent };